import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from 'src/app/core/services/toast.service';
import {
  dateOfNextMonth,
} from 'src/app/shared/constants/date-format';
import { VariableValueDto } from 'src/app/shared/dto/variable-value.dto';
import { VariableValueService } from 'src/app/shared/http-services/variable-value.service';
import { Parking } from 'src/app/shared/models/parking.model';
import { formatDate } from 'src/app/shared/utils/utils-global';
import { Nullable } from '../../constants/types';

@Component({
  selector: 'app-parking-variable',
  templateUrl: './parking-variable.component.html',
  styleUrls: ['./parking-variable.component.scss'],
})
export class ParkingVariableComponent implements OnInit {
  public readonlyParkings: Parking[] = [];
  public editableParkings: Parking[] = [];
  public startingOn = dateOfNextMonth();
  public minDate = dateOfNextMonth();
  @Input() public currentSiteId: Nullable<number> = 0;
  @Input() public set parkings(parkings: Parking[]) {
    this.readonlyParkings = [];
    this.editableParkings = [];
    parkings.forEach(v => {
      if (v.isCurrentApplicable) {
        this.readonlyParkings.push(v);
      }
      if (v.isFutureApplicable) {
        this.editableParkings.push(v);
      }
    });
    if (!this.editableParkings.length) {
      this.editableParkings = JSON.parse(JSON.stringify(this.readonlyParkings));
      this.editableParkings = this.editableParkings.map((v: Parking) => {
        v.value = 0;
        v.isCurrentApplicable = false;
        v.isFutureApplicable = true;
        return new Parking(v);
      });
    }
    if (this.editableParkings.length && this.editableParkings[0].validFrom) {
      this.startingOn = new Date(this.editableParkings[0].validFrom);
    }
  }
  constructor(
    private variableValueService: VariableValueService,
    private translateService: TranslateService,
    private toastService: ToastService,
  ) {}

  ngOnInit(): void {}

  public onEdit(): void {
    const value: VariableValueDto[] = this.editableParkings.map(v => {
      return {
        variableId: v.variableId,
        homebaseId: this.currentSiteId,
        value: +v.value,
        validFrom: formatDate(this.startingOn),
      };
    });

    this.variableValueService.updateVariableValue(value).subscribe(res => {
      if (res.code < 0) {
        const message = this.translateService.instant(res.data);
        this.toastService.showWarn(message);
      } else {
        this.startingOn = new Date(res.data);
        const message = this.translateService.instant(
          'UPDATE_VARIABLE_SUCCESSFUL',
        );
        this.toastService.showSuccess(message);
      }
    });
  }
}
